module.exports = __webpack_public_path__ + "static/tande-e4e894e6562f6876a445fa977373c495.jpg";